<template>
    <trax-ui-horizontal-tabs :tabs="tabs" tab-style="plain">
        <template slot="tab-1">
            <enac-atpl-dashboard-phase-learners></enac-atpl-dashboard-phase-learners>
        </template>
        <template slot="tab-2">
            <enac-procedure-atp-daf-group-widget></enac-procedure-atp-daf-group-widget>
        </template>
    </trax-ui-horizontal-tabs>
</template>

<script>
    export default {
    
        data: function() {
            return {
                lang: lang,
                tabs: [
                    {value: 'learners', name: lang.polaris.dashboard.learners, icon: 'people'},
                    {value: 'atp-daf', name: lang.polaris.procedure.atp_daf, icon: 'call_missed_outgoing'},
                ]
            }
        }

    }
</script>
